<template>
  <section class="plastic-section">
    <div class="container">
      <div class="plastic-image-container" id="plasticImage">
        <img
          :src="require('@/assets/image/plastic-section/phone.png')"
          alt="plastic"
          class="plastic_1">
        <img
          :src="require('@/assets/image/plastic-section/phone_2.png')"
          alt="plastic"
          class="plastic_2">
      </div>
      <div class="plastic-text-container">
        <div class="about">
          <div class="about__heading">
            <span>№5</span> Меньше <br>пластика
          </div>
          <div class="about__text" id="plasticText">
            <div class="first-text">
              Для снижения вреда от пластиковых отходов Apple
              отказалась от адаптера питания в комплекте с iPhone,
              бренд Xiaomi на 60% сократит количество пластика в
              упаковке, Samsung создаст ее из бумаги или картона,
              а МТС поддерживает тренд и предлагает своим клиентам
              виртуальные банковские карты<br><br>
              В свободное время выпустите для себя виртуальную
              карту MTS CASHBACK в Мой МТС. Попробуйте, это удобно и выгодно
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';

export default {
  name: 'v-plastic-section',
  mounted() {
    const timelinePlastic = gsap.timeline({
      scrollTrigger: {
        trigger: '.plastic-section',
        start: '-=20%',
        end: 'bottom',
        scrub: 1,
        onUpdate: (self) => {
          console.log('progress7:', self.progress);
          document.body.style.background = '#F4F4F4';
          const plasticImage = document.getElementById('plasticImage');
          if (self.progress > 0.11 && !plasticImage.classList.contains('active')) {
            plasticImage.classList.add('active');
          }
          if (self.progress < 0.11 && plasticImage.classList.contains('active')) {
            plasticImage.classList.remove('active');
          }
        },
      },
    });
    timelinePlastic.addLabel('start');
  },
};
</script>

<style lang="scss">
.plastic-section{
  position: relative;
  padding-top: 100px;
  min-height: calc(var(--vh)*110);
  padding-bottom: 100px;

  .container{
    position: sticky;
    top: 20px;
  }

  .about__text{
    position: relative;

    .first-text{
      position: relative;
      opacity: 1;
      transition: opacity .15s ease-in-out;
    }
  }
}

.plastic-image-container{
  position: relative;
  max-height: calc(var(--vh)*48);

  img{
    position: relative;
    width: 100%;
    top: 0;
    transition: opacity .15s ease-in-out;
  }

  .plastic_1{
    opacity: 1;
  }

  .plastic_2{
    position: absolute;
    left: 0;
    opacity: 0;
  }

  &.active{
    .plastic_1{
      opacity: 0;
    }
    .plastic_2{
      opacity: 1;
    }
  }
}
</style>
